// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../../../../Config.bs.js";
import * as CountryConfig from "../../country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as VehicleRepoConfig from "./VehicleRepoConfig.bs.js";
import * as NetworkV2$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";

function fetchVehicleTypes(geo_region_id, country) {
  var urlParams = {};
  urlParams["geo_region_id"] = String(geo_region_id);
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/geo_regions/active_vehicles", urlParams);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(VehicleRepoConfig.VehicleTypesResponseConverter.execute, result);
                        });
            });
}

function useVehicleTypes(geo_region_id, country) {
  var match = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var updateVehicleTypes = match[1];
  var $$fetch = function (geo_region_id) {
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return fetchVehicleTypes(geo_region_id, country);
                }), (function (data) {
                  return Curry._1(updateVehicleTypes, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(updateVehicleTypes, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          $$fetch(geo_region_id);
          
        }), []);
  return [
          match[0],
          $$fetch
        ];
}

var VehicleRepo = {
  fetchVehicleTypes: fetchVehicleTypes,
  useVehicleTypes: useVehicleTypes
};

export {
  VehicleRepo ,
  
}
/* react Not a pure module */
